// MARK://dhk8/guest/lib/gql
// Cliente GraphQL (urql) del Auto-Servicio (comensal) — apunta al
// graphql-gateway vía el rest-proxy (`${VITE_API_BASE}/graphql`, MISMO origin
// que el REST → reusa CORS).
//
// El comensal se autentica con el token de sesión guest (capability token del
// QR de mesa), que vive en `useSessionStore`. Lo adjuntamos como
// `Authorization: Bearer` si existe; el menú público no lo requiere.
// `preferGetMethod:false` porque urql manda queries como GET y el gateway
// (Apollo) las bloquea por CSRF. Refs: ADR-0002, ADR-0003.
import { Client, fetchExchange, cacheExchange } from 'urql'
import { useSessionStore } from '../stores/session.store.js'

const GQL_URL = `${import.meta.env.VITE_API_BASE ?? ''}/graphql`

function withAuth(init: RequestInit | undefined): RequestInit {
  const token = useSessionStore.getState().session?.token ?? null
  // urql pasa `init.headers` como `Headers`; mergear con `new Headers` preserva
  // el `content-type: application/json` (si no, Apollo lo bloquea como CSRF).
  const headers = new Headers(init?.headers ?? {})
  if (token) headers.set('Authorization', `Bearer ${token}`)
  return { ...init, credentials: 'include', headers }
}

const gqlFetch: typeof fetch = (input, init) => fetch(input, withAuth(init))

export const gqlClient = new Client({
  url: GQL_URL,
  preferGetMethod: false,
  exchanges: [cacheExchange, fetchExchange],
  fetch: gqlFetch,
})

// Hook de smoke/diagnóstico (solo dev).
if (typeof window !== 'undefined' && import.meta.env.DEV) {
  ;(window as unknown as { __gqlClient?: Client }).__gqlClient = gqlClient
}
